module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": true
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.params.id ? '编辑' : '新增') + "优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "box content"
  }, [_c('section', {
    staticClass: "phone-show"
  }, [_c('h3', [_vm._v("优惠券")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-cont",
    class: _vm.params.color
  }, [_c('div', {
    staticClass: "logo-cont"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.logo_url || '../../../../public/logo.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "coupon-dtl"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userInfo.username || '请完善商户名称'))]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.params.title || '优惠券名称'))]), _vm._v(" "), _c('h5', {
    staticClass: "fx-align"
  }, [_c('p', [_c('span', [_vm._v("￥")]), _vm._v(_vm._s(_vm.params.reduce_cost || 'XX'))])]), _vm._v(" "), _c('div', {
    staticClass: "condition m-t-10"
  }, [_c('span', [_vm._v("使用条件：")]), _vm._v("消费满" + _vm._s(_vm.params.least_cost || 'xx') + "元可用")]), _vm._v(" "), _c('div', {
    staticClass: "condition m-t-5"
  }, [_c('span', [_vm._v("可否共享：")]), _vm._v(_vm._s(_vm.params.is_shared == 'Y' ? '可与其他优惠活动共享' : '不与其他优惠活动共享'))]), _vm._v(" "), (_vm.picker_date[0] != null && _vm.picker_date[1] != null) ? _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("可用时间：")]), _vm._v(_vm._s(_vm._f("momentFmt")(_vm.picker_date[0], "YYYY.MM.DD")) + "-" + _vm._s(_vm._f("momentFmt")(_vm.picker_date[1], "YYYY.MM.DD")))]) : _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("可用时间：")]), _vm._v("xxxx.xx.xx-xxxx.xx.xx")]), _vm._v(" "), _c('div', {
    staticClass: "box explain"
  }, [_c('div', [_vm._v("使用说明：")]), _c('p', {
    staticClass: "box-flex c-f-s"
  }, [_vm._v(_vm._s(_vm.params.description || '这里是使用说明'))])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('section', {
    staticClass: "menu-edit b-r-5 box-flex"
  }, [_c('div', {
    staticClass: "w400"
  }, [_c('z-input', {
    attrs: {
      "title": "优惠券名称",
      "maxlength": "9",
      "isMust": "true",
      "placeholder": "用优惠亮点，吸引顾客领取"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.title"
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w400 m-t-20"
  }, [_c('z-input', {
    attrs: {
      "type": "number",
      "title": "发放总量",
      "isMust": "true",
      "placeholder": "输入发放数量"
    },
    model: {
      value: (_vm.params.quantity),
      callback: function($$v) {
        _vm.$set(_vm.params, "quantity", _vm._n($$v))
      },
      expression: "params.quantity"
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    staticClass: "w400 m-t-20"
  }, [_c('z-input', {
    attrs: {
      "type": "number",
      "title": "优惠券面值",
      "isMust": "true",
      "placeholder": "设置优惠券面值"
    },
    model: {
      value: (_vm.params.reduce_cost),
      callback: function($$v) {
        _vm.$set(_vm.params, "reduce_cost", _vm._n($$v))
      },
      expression: "params.reduce_cost"
    }
  }), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('div', {
    staticClass: "box m-t-20"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-bg box-flex"
  }, [_c('ul', {
    staticClass: "fx fx-wrap w400"
  }, [_c('li', {
    staticClass: "color010",
    class: {
      'active': _vm.params.color == 'Color010'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color010')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color020",
    class: {
      'active': _vm.params.color == 'Color020'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color020')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color030",
    class: {
      'active': _vm.params.color == 'Color030'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color030')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color040",
    class: {
      'active': _vm.params.color == 'Color040'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color040')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color050",
    class: {
      'active': _vm.params.color == 'Color050'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color050')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color060",
    class: {
      'active': _vm.params.color == 'Color060'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color060')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color070",
    class: {
      'active': _vm.params.color == 'Color070'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color070')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color080",
    class: {
      'active': _vm.params.color == 'Color080'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color080')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color081",
    class: {
      'active': _vm.params.color == 'Color081'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color081')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color082",
    class: {
      'active': _vm.params.color == 'Color082'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color082')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color090",
    class: {
      'active': _vm.params.color == 'Color090'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color090')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color100",
    class: {
      'active': _vm.params.color == 'Color100'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color100')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color101",
    class: {
      'active': _vm.params.color == 'Color101'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color101')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "color102",
    class: {
      'active': _vm.params.color == 'Color102'
    },
    on: {
      "click": function($event) {
        return _vm.handleChooseColor('Color102')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-flex m-l-5"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "选择时间范围"
    },
    model: {
      value: (_vm.picker_date),
      callback: function($$v) {
        _vm.picker_date = $$v
      },
      expression: "picker_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20 w400"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center w120 m-l-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.params.get_limit),
      expression: "params.get_limit",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input m-r-10",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.params.get_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "get_limit", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v("张")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "w400"
  }, [_c('div', {
    staticClass: "fx fx-y-center m-t-20 w400"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center w200"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.params.least_cost),
      expression: "params.least_cost",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.params.least_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "least_cost", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_c('p', {}, [_vm._v("优惠同享：")]), _vm._v(" "), _c('z-select', {
    staticClass: "w200",
    attrs: {
      "options": _vm.is_shared_arr
    },
    model: {
      value: (_vm.params.is_shared),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_shared", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.is_shared"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-y-center m-t-20"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "box-flex"
  }, [_c('el-transfer', {
    attrs: {
      "titles": ['全部门店', '已选门店'],
      "data": _vm.transfer_data
    },
    model: {
      value: (_vm.params.shop_list),
      callback: function($$v) {
        _vm.$set(_vm.params, "shop_list", $$v)
      },
      expression: "params.shop_list"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "m-t-20"
  }, [_c('z-input', {
    attrs: {
      "title": "使用说明",
      "type": "textarea",
      "isMust": "true",
      "placeholder": "请填写使用本优惠券的注意事项"
    },
    model: {
      value: (_vm.params.description),
      callback: function($$v) {
        _vm.$set(_vm.params, "description", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "params.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 box"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleValidate
    }
  }, [_vm._v("保存")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "fx fx-x-between fx-y-center"
  }, [_c('p', [_vm._v("适用门店")]), _c('p', {
    staticClass: "icon-back"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box m-t-5"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "pic-tips"
  }, [_vm._v("Tips：字数上限为9个汉字,建议填写优惠券“减免金额”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box m-t-5"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "pic-tips"
  }, [_vm._v("Tips：优惠券发放总量，上限为100000000张")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box m-t-5"
  }, [_c('p', {
    staticClass: "w120 m-r-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "pic-tips"
  }, [_vm._v("Tips：优惠面值只能是大于0.01的数字")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w120 m-r-5 m-t-5 fx"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("卡券封面")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "w120 fx"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("有效期")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fx w120"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("领券限制")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box m-t-10"
  }, [_c('p', {
    staticClass: "fx w120 m-l-5"
  }), _vm._v(" "), _c('p', {
    staticClass: "pic-tips"
  }, [_vm._v("Tips：每个用户领券上限，如不填，则默认为1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fx w120 m-r-5"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("使用条件")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fx "
  }, [_c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("最低消费：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box m-t-10"
  }, [_c('p', {
    staticClass: "pic-tips"
  }, [_vm._v("Tips：消费金额大于0且只能到百分位！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "m-r-10 w120"
  }, [_c('i', {
    staticClass: "ask"
  }, [_vm._v("*")]), _c('span', {
    staticClass: "fx-fill"
  }, [_vm._v("适用门店")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7ca15cd1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/marketing/coupon/Edit.vue
// module id = 871
// module chunks = 0